<template>
    <button v-if="hasExportAccess" class="d-flex align-items-center" type="button" @click="exportCsv">
        <i class="me-2 bi-upload"/>
        Export CSV
    </button>
</template>

<script>
export default {
    name: "ListingOptionsExportBtn",
    props: {
        viewId: String,
    },
    computed: {
        listingName() {
            return this.$store.state[this.viewId].listingName
        },
        tableName() {
            return this.$store.state[this.viewId].tableName
        },
        hasExportAccess() {
            return this.$store.getters['user/access'](this.tableName, 'export')
        },
        allIds() {
            return this.$store.state[this.viewId].allIds
        },
        productId() {
            return parseInt(this.$route.query.productId)
        }
    },
    asyncComputed: {
        productTitle() {
            if (this.productId) {
                return this.$store.dispatch('itemData/get', {
                        tableName: 'm_products_products',
                        id: this.productId
                    })
                    .then(o => o.title)
            }
        }
    },
    methods: {
        async exportCsv() {
            if (confirm('Are you sure?\nPlease be patient as this may take a minute.')) {

                let exportFileName = ''
                if (this.tableName.indexOf('product_variations__') === 0) {
                    exportFileName = this.productTitle
                } else {
                    const component = this.$store.state.components.items.find(o => o.tableName === this.tableName)
                    exportFileName = component.title
                }

                // Generate a notification before we start the process. This notification ID is then provided to the
                // export request so that it can update its progress.
                const {notificationId} = await this.$store.dispatch('toasts/notification', {
                    title: exportFileName + ' export',
                    body: 'Starting&hellip;',
                    downloadUrl: '',
                    closeOnDownload: true
                })

                try {
                    await this.$store.dispatch('request/post', {
                        url: this.$store.state.apiEndpoint + '/api/export',
                        postData: {
                            notificationId,
                            buildName: this.$store.state.sitename,
                            tableName: this.tableName,
                            ids: this.allIds,
                            title: exportFileName
                        }
                    })
                } catch (error) {
                    console.error('Export failed:', error)
                }
            }
        }
    }
}
</script>

<style scoped>

</style>